import { usePerson } from 'entities/person/lib/hooks/usePerson';
import { FC, useEffect, useState } from 'react';
import { CloseIconButton } from 'shared/ui/buttons/iconButtons/closeButton';
import { Flex } from 'shared/ui/flex';
import { Header } from './styles';
import { InputSearch } from 'shared/ui/inputSearch';
import { SearchContainer } from './styles';
import { useDebounceCallback } from 'shared/lib/debounce';
import { Typography } from 'shared/ui/typography';
import { usePaginationFilterPersons } from 'shared/lib/pagination';
import { PaginationHook } from 'shared/lib/pagination';
import { useAppSelector } from 'shared/lib/store';
import { selectBookingApplicationMod } from 'entities/orders';
import { ModalProvider } from 'shared/ui/modal';
import { PersonModalEdit } from 'widgets/personModalCard/ui/personModalEdit';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';
import { selectPerson } from 'entities/person/model/selector';

interface PersonBookHeaderProps { }

export const PersonBookHeader: FC<PersonBookHeaderProps> = () => {
  const ActionButtonTextWithFeedback = withAsyncActionFeedback(ButtonContained);

	const { setOpenPersonBook, setSearchMode, searchMode, isOpenPersonBook, setPerson } =
		usePerson();
	const { fetchDataWithDispatch, filters } =
		usePaginationFilterPersons() as PaginationHook;
	const [isResetSearch, resetSearchInput] = useState<boolean>(false);
  const [ openConfirm, setOpenConfirm ] = useState<boolean>(false);
	const applicationMod = useAppSelector(selectBookingApplicationMod);
  const person = useAppSelector(selectPerson);


	const closePersonBook = () => {
		setOpenPersonBook(false);
		setSearchMode('searchByName');
		resetSearchInput(true);
	};

	const debouncedDispatch = useDebounceCallback((search: string) => {
		fetchDataWithDispatch({ search, page: 1 });
	}, 500);

	const search = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const search = event.target.value;
		debouncedDispatch(search);
	};

	useEffect(() => {
		if (isOpenPersonBook) {
			resetSearchInput(false);
		}
	}, [isOpenPersonBook]);

  const addGuestInOrder = () => {
    setOpenConfirm(true);
  }

  const addGuestInOrderReset = () => {
    setOpenConfirm(false);
  }

  const addGuestInOrderConfirm = async () => {
    await setPerson(person);
    setOpenConfirm(false);
  }

	return (
		<Header>
			<Flex $justify="space-between">
				{searchMode === 'searchByName' ? (
					<SearchContainer>
						<InputSearch onChange={search} clear={isResetSearch} />
            <ModalProvider>
              <PersonModalEdit
                updatePersonBook={false}
                updateOrder={'none'}
                headerContent="Создание нового гостя"
                isCreate={true}
                addGuestInOrder={addGuestInOrder}
              />
            </ModalProvider>
            {openConfirm && (
              <ModalProvider openByDefault>
                <Confirm
                  title={'Добавить нового гостя в бронирование?'}
                  showCancelButton={false}
                  confirmButton={
                    <>
                      <ActionButtonTextWithFeedback
                        onClick={addGuestInOrderConfirm}
                      >
                        Добавить
                      </ActionButtonTextWithFeedback>
                      <ButtonOutlined
                        color="danger"
                        isFullWidth
                        onClick={addGuestInOrderReset}
                      >
                        Не добавлять
                      </ButtonOutlined>
                    </>
                  }
          
                />
              </ModalProvider>
            )}
					</SearchContainer>
				) : (
					<Typography mode={'large'}>
						Поиск по номеру телефона: {filters.search}
					</Typography>
				)}
				{!applicationMod && (
					<CloseIconButton onClick={closePersonBook} />
				)}
			</Flex>
		</Header>
	);
};
